export interface Partner {
  id: string;
  name: string;
  role: string;
  description: string;
  logoLabel: string;
}

export const partners: Partner[] = [
  {
    id: 'btec',
    name: 'BUSAN TECHNOPARK ENTERPRISE COUNCIL (BTEC)',
    role: 'Co-founder & Korean Partner',
    description: 'BTEC facilitates business connections and supports Korean enterprises in expanding internationally. Through BCBH, BTEC enables Korean companies to access Egyptian market opportunities and establish strategic partnerships.',
    logoLabel: 'BTEC Logo',
  },
  {
    id: 'lohmann',
    name: 'LOHMANN ECCE for Infrastructure & Clean Energy S.A.E.',
    role: 'Co-founder & Egyptian Bridge Partner',
    description: 'LOHMANN ECCE serves as the bridge enabling knowledge-sharing and business opportunities between Korea and Egypt. As the Egyptian partner, LOHMANN ECCE facilitates connections, coordinates missions, and supports joint ventures.',
    logoLabel: 'LOHMANN ECCE Logo',
  },
  {
    id: 'btp',
    name: 'BUSAN TECHNOPARK (BTP)',
    role: 'Supporting Partner',
    description: 'BTP provides facility support in Busan for BCBH operations, hosting meetings and events. BTP contributes infrastructure and resources to enable BCBH activities in Korea.',
    logoLabel: 'BTP Logo',
  },
];

